import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/parkmundo.webp';
import screenshot_target from '../../../images/letterfunnel/mikaeilshaghelani.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Mikaeil Shaghelani"
      firstname="Mikaeil"
      companyname="ParkMundo"
      competition="Parkos en Looking4Parking"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/mikaeilshaghelani.js